import { createContext } from 'react';
import { Direction } from '../../common/direction.mjs';
import { jsx } from 'react/jsx-runtime';

const DirectionContext = /*#__PURE__*/createContext(Direction.LTR);
const DirectionProvider = ({
  direction,
  children
}) => {
  return /*#__PURE__*/jsx(DirectionContext.Provider, {
    value: direction,
    children: children
  });
};

export { DirectionContext, DirectionProvider };
//# sourceMappingURL=DirectionProvider.mjs.map
